import toString from './to-string';
var upperCase = function (str) {
    return toString(str).toUpperCase();
};
export default upperCase;
//# sourceMappingURL=upper-case.js.map